import type { Locale } from '@skytech/types'

import { LEADING_ZEROS_PATTERN } from '@skytech/utils'

export function isOnlyLetters(val: string | number) {
  if (typeof val === 'number') return false

  return !/\d/.test(val)
}

export function isOnlyDigits(val: string | number) {
  if (typeof val === 'number') return true

  return /^[0-9]+$/.test(val)
}

export const getFormattedNumber = ({
  locale,
  amount,
  precision = 2,
}: {
  locale: Locale
  amount: number
  precision?: number
}) => amount.toLocaleString(locale, { maximumFractionDigits: precision })

export function isStringOfLength(val: string, length: number) {
  return val.length === length
}

export const trimLeadingZeros = (val: string | number) => {
  let value = typeof val === 'number' ? String(val) : val
  const trimmed = value.replace(LEADING_ZEROS_PATTERN, '')
  if (trimmed.startsWith('.')) {
    return '0' + trimmed
  }
  return trimmed || '0'
}
